import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OpenAppService } from '../service/open-app.service';

export const appLoaderGuard: CanActivateFn = () => {
  const openAppService = inject(OpenAppService);
  if (openAppService.isLoaded) {
    return true;
  }
  return openAppService.isLoaded$;
};
